import React from "react";
import { useDroppable } from "@dnd-kit/core";
import type { KanbanColumn } from "../../types/pipeline.types";
import type { StatusConfig } from "../StatusControl/types";

interface StatusKanbanColumnProps {
  column: KanbanColumn;
  statusConfig: Record<string, StatusConfig>;
  children: React.ReactNode;
  itemCount: number;
}

export const StatusKanbanColumn: React.FC<StatusKanbanColumnProps> = ({
  column,
  statusConfig,
  children,
  itemCount,
}) => {
  const droppableId = `status-col-${column.key}`;
  const { setNodeRef, isOver } = useDroppable({ id: droppableId });

  const primaryStatus = column.statuses[0];
  const config = statusConfig[primaryStatus];
  const headerColor = config?.color || "#6b7280";

  return (
    <div
      ref={setNodeRef}
      className={`status-kanban-column ${isOver ? "status-kanban-column--dropping" : ""}`}
      data-testid={`board-column-${column.key}`}
    >
      <div
        className="status-kanban-column__header"
        style={{ backgroundColor: headerColor }}
      >
        <h3 title={column.label}>{column.label}</h3>
        <span className="status-kanban-column__count">{itemCount}</span>
      </div>
      <div className="status-kanban-column__content">
        {itemCount > 0 ? (
          children
        ) : (
          <div className="status-kanban-column__empty">
            <p>No items</p>
          </div>
        )}
      </div>
    </div>
  );
};
